import * as React from 'react';

import { IControlError, IControlSchema } from '../../Controls';
import { Component, I18NString, isNullOrEmpty } from '../../Utils';
import { IDispatcher } from '../extensions/Dispatcher';
import Field from '../Field';
import { isUndefined, isNull, isArray, isEmpty } from 'lodash';
import Alert from './Alert';
import Select from 'react-select';
import { isNullOrUndefined, isObject } from 'util';
import { type } from 'os';

export interface IDropBoxOptionSchema {
  key: string;
  value: I18NString;
}

export interface IDropBoxSchema extends IControlSchema {
  description: I18NString;
  options: Array<IDropBoxOptionSchema>;
  value?: any;
  disabled?: boolean;
  multi?: boolean;
  extra?: any;
}

export interface IDropBoxProps {
  schema: IDropBoxSchema;
  dispatcher?: IDispatcher;
  error: IControlError | undefined;
  visited: boolean;
}

interface State {
  openInfo: boolean;
}

class DropBox extends Component<IDropBoxProps, State> {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onClick = this.onClick.bind(this);
    this.state = {
      openInfo: false,
    };
  }

  protected onChange(select) {
    const { dispatcher } = this.props;
    if (isArray(select)) {
      dispatcher.onAddValueRefresh(
        this.props.schema.id,
        isEmpty(select) ? null : select,
        undefined,
      );
    } else {
      const value = isNull(select) ? null : select.value === 0 ? null : select; //isObject(select.value) ? select : select.value;
      dispatcher.onAddValueRefresh(
        this.props.schema.id,
        isNull(value) ? null : value,
        undefined,
      );
    }

    if (
      typeof this.props.schema.extra !== 'undefined' &&
      isArray(this.props.schema.extra.onChange)
    ) {
      this.props.schema.extra.onChange.map((action) => {
        if (
          typeof action.field !== 'undefined' &&
          typeof action.value !== 'undefined' &&
          action.value !== '' &&
          !isNull(select)
        ) {
          dispatcher.onAddValueRefresh(
            action.field,
            select[action.value],
            undefined,
          );
        }
      });
    }
  }

  componentDidMount() {
    if (
      typeof this.props.schema.extra !== 'undefined' &&
      this.props.schema.extra.showHelp
    ) {
      this.setState({ openInfo: true });
    }
  }

  onClick() {
    this.setState({ openInfo: !this.state.openInfo });
  }

  public render() {
    const {
      schema: { disabled, description, multi },
      visited,
      error,
    } = this.props;
    const arr = this.props.schema?.options.map((o: IDropBoxOptionSchema) => ({
      ...o,
      value: o.key,
      label: o.value.ru,
    }));
    const errorMessage = visited && error && error.message;

    const valueId = arr.findIndex((el) => el.key === this.props.schema.value);
    const value =
      typeof arr[0] !== 'undefined' && isObject(arr[0].value)
        ? arr[valueId]
        : this.props.schema.value;

    // console.log('SCHEMA', arr, this.props.schema.value);

    let statusField = 'default';
    if (!isNullOrUndefined(value) && !this.props.schema.disabled) {
      statusField = 'success';
    }

    return (
      <Field
        {...this.props.schema}
        status={isNullOrUndefined(value) ? 'default' : 'success'}
        helpBtn={
          description && (
            <span
              onClick={this.onClick}
              className="input-group-addon btn btn-default btn-circle"
            >
              <span className="glyphicon glyphicon-question-sign"></span>
            </span>
          )
        }
      >
        <div className="input-group">
          <Select
            autosize={false}
            multi={multi}
            name="form-field-name"
            className={`has-success dropbox ${
              statusField === 'default' ? 'dropbox--alert' : ''
            }`}
            placeholder="Выберите из списка"
            value={value}
            disabled={disabled}
            onChange={this.onChange}
            options={arr}
          />
          {
            // (description) && (
            //   <span onClick={this.onClick} className="input-group-addon btn btn-default btn-circle">
            //       <span className="glyphicon glyphicon-question-sign"></span>
            //   </span>
            // )
          }
        </div>
        {description && this.state.openInfo && (
          <div
            className="alert alert-warning"
            role="alert"
            dangerouslySetInnerHTML={{
              __html: this.tr(this.props.schema.description),
            }}
          ></div>
        )}
        {errorMessage && <Alert>{errorMessage}</Alert>}
      </Field>
    );
  }
}

export function createDropBox(
  schema: IControlSchema,
  dispatcher: IDispatcher = null,
  error: IControlError | undefined,
  visited: boolean,
): React.ReactElement<any> {
  return (
    <DropBox
      schema={schema as IDropBoxSchema}
      dispatcher={dispatcher}
      error={error}
      visited={visited}
    />
  );
}
